<template>
  <v-form :value="valid" @input="v => $emit('update:valid', v)" @submit.prevent>
    <v-row dense>
      <v-col cols="12">
        <j-date-picker
          label="Date"
          filled
          dense
          class="no-before"
          :value="date"
          @input="v => $emit('update:date', v)"
          required
        ></j-date-picker>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <j-decimal-input
          label="Ventes nettes"
          :value="value"
          :min="0"
          @input="
            v => {
              $emit('update:value', v);
              $emit('updateValue');
            }
          "
          filled
          dense
          class="no-before"
          required
        ></j-decimal-input>
      </v-col>
    </v-row>
    <div
      v-for="optionalValueNumber in [1, 2, 3, 4, 5]"
      :key="optionalValueNumber"
    >
      <v-row
        no-gutters
        dense
        v-if="
          showConfig === false &&
            getSaleOptionalValues.find(
              x => x.value_number === optionalValueNumber
            ) !== undefined
        "
      >
        <j-decimal-input
          :label="
            getSaleOptionalValues.find(
              x => x.value_number === optionalValueNumber
            ).name
          "
          :value="getOptionalValueValue(optionalValueNumber)"
          :min="0"
          @input="v => optionalValueChangeHandler(v, optionalValueNumber)"
          :suffix="
            `$ (${getSaleOptionalValues.find(
              x => x.value_number === optionalValueNumber
            ).ratio * 100}%)`
          "
          filled
          dense
          class="no-before"
          required
        ></j-decimal-input
      ></v-row>
      <SaleOptionalValueConfig
        :index="optionalValueNumber"
        v-else-if="showConfig === true"
      ></SaleOptionalValueConfig>
    </div>
    <v-row dense v-show="getSaleOptionalValues.length > 0">
      <v-col :cols="showActions === true ? 11 : 12">
        <j-decimal-input
          label="Ventes nettes après marge de perte"
          :value="value_before_tx"
          :min="0"
          @input="
            v => {
              $emit('update:value_before_tx', v);
              $emit('updateAvTx');
            }
          "
          filled
          dense
          class="no-before"
          required
        ></j-decimal-input>
      </v-col>
      <v-col v-if="showActions === true">
        <v-row
          dense
          no-gutters
          align="center"
          justify="end"
          style="height: 100%;"
        >
          <v-btn small icon @click="$emit('calculate-before-tax')">
            <v-icon>fa-calculator</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="4">
        <j-decimal-input
          label="Tps"
          :value="tps"
          :min="0"
          @input="
            v => {
              $emit('update:tps', v);
              $emit('updateTx');
            }
          "
          filled
          dense
          class="no-before"
          required
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="4">
        <j-decimal-input
          label="Tvq"
          :value="tvq"
          :min="0"
          @input="
            v => {
              $emit('update:tvq', v);
              $emit('updateTx');
            }
          "
          filled
          dense
          class="no-before"
          required
        ></j-decimal-input>
      </v-col>
      <v-col
        :cols="showActions === true ? 11 : 12"
        :sm="showActions === true ? 3 : 4"
      >
        <j-decimal-input
          label="Ventes brutes"
          :value="value_after_tx"
          :min="0"
          @input="v => $emit('update:value_after_tx', v)"
          filled
          dense
          class="no-before"
          required
        ></j-decimal-input>
      </v-col>
      <v-col v-if="showActions === true">
        <v-row
          dense
          no-gutters
          align="center"
          justify="end"
          style="height: 100%;"
        >
          <v-btn small icon @click="$emit('calculate-tax')">
            <v-icon>fa-calculator</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import SaleOptionalValueConfig from "./SaleOptionalValueConfig.vue";
export default {
  name: "SalesInput",
  components: {
    SaleOptionalValueConfig
  },
  props: {
    date: {
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    optional_value_1: {
      required: true
    },
    optional_value_2: {
      required: true
    },
    optional_value_3: {
      required: true
    },
    optional_value_4: {
      required: true
    },
    optional_value_5: {
      required: true
    },
    value_before_tx: {
      type: Number,
      required: true
    },
    tps: {
      type: Number,
      required: true
    },
    tvq: {
      type: Number,
      required: true
    },
    value_after_tx: {
      type: Number,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    },
    showConfig: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getSaleOptionalValues"])
  },
  methods: {
    getOptionalValueValue(index) {
      return this[`optional_value_${index}`];
    },
    optionalValueChangeHandler(v, index) {
      this.$emit(`update:optional_value_${index}`, v);
      this.$emit("updateOptionalValues");
    }
  }
};
</script>

<style></style>
